/// 两套红绿调色板，语义不同，禁止互换（见 frontend/README §6.3）：
/// - BID_/ASK_：Antd 默认色，仅用于盘口买卖档位。
/// - GAIN_/LOSS_：signals 涨跌色，与 main.tsx 的 colorSuccess/colorError
///   theme token 保持一致。

// Antd 默认色 — 盘口买卖（不要与 GAIN/LOSS 混用）。
export const BID_GREEN = '#52c41a';
export const ASK_RED = '#ff4d4f';
export const BID_BAR_BG = 'rgba(82, 196, 26, 0.18)';
export const ASK_BAR_BG = 'rgba(255, 77, 79, 0.18)';

// signals 涨跌色。
export const GAIN_GREEN = '#0cce6b';
export const LOSS_RED = '#ee0000';
export const NEUTRAL_GREY = '#8c8c8c';
export const MUTED_TEXT = '#666';
